<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 17:53:59
 * @Description: 校验个人信息
-->
<template>
	<div class="verify_info">
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<Form class="vertical_self_form" @submit="handleSubmit">
			<Field
				v-model="form.username"
				name="username"
				:label="$t('webapp.forget.username')"
				:placeholder="$t('webapp.forget.username_placeholder')"
				:show-error-message="false"
				:scroll-to-error="true"
				:rules="[{ required: true }]"
			></Field>
			<Field
				v-model="form.displayName"
				name="displayName"
				:label="$t('webapp.activate.name')"
				:placeholder="$t('login.activate.name_placeholder')"
				:show-error-message="false"
				:scroll-to-error="true"
			></Field>
			<Field
				readonly
				clickable
				v-model="form.birthDate"
				name="birthDate"
				:label="$t('webapp.forget.birth')"
				:placeholder="$t('webapp.forget.birth_placeholder')"
				:show-error-message="false"
				:scroll-to-error="true"
				@click="birthPicker = true"
				clearable
			></Field>
			<Field
				v-model="form.idCardNo"
				name="idCardNo"
				:placeholder="$t('base.input')"
				:show-error-message="false"
				:scroll-to-error="true"
				:rules="[{ required: true }]"
			>
				<template #label>
					<div class="code_type_label" @click="codeTypeChange">
						<span>{{ codeList.find((o) => o.value == form.idType).text }}</span>
						<Icon class="c_l_s_right" name="arrow" />
					</div>
				</template>
			</Field>

			<div style="margin: 16px">
				<Button round block type="info" native-type="submit">下一步</Button>
			</div>
		</Form>

		<!-- 选择日期 -->
		<Popup v-model="birthPicker" position="bottom">
			<DatetimePicker
				v-model="currentDate"
				type="date"
				title="选择日期"
				:min-date="minDate"
				@cancel="birthPicker = false"
				@confirm="birthPickerConfirm"
			/>
		</Popup>

		<!-- 选择身份类型 -->
		<Popup v-model="codeTypePicker" position="bottom">
			<Picker
				show-toolbar
				:columns="codeList"
				:default-index="defaultType"
				@confirm="codeTypePickerConfirm"
				@cancel="codeTypePicker = false"
			/>
		</Popup>
	</div>
</template>

<script>
import { NavBar, Form, Field, Button, Popup, DatetimePicker, Picker, Icon } from "vant";
import moment from "moment";
import { toast } from "@/utils/toast";
import { commonAPI } from "@/apis";
import { mapGetters } from "vuex";

export default {
	name: "VerifyInfo",
	components: { NavBar, Form, Field, Button, Popup, DatetimePicker, Picker, Icon },
	data() {
		return {
			form: { username: "", displayName: "", birthDate: "", idCardNo: "", idType: "1" },
			codeList: [
				{ text: this.$t("base.idCard"), value: "1" },
				{ text: this.$t("base.passport"), value: "2" },
				{ text: this.$t("base.gatCard"), value: "3" },
				{ text: this.$t("base.other"), value: "4" },
			],
			defaultType: 0,
			codeTypePicker: false,
			birthPicker: false,
			minDate: new Date(1900, 0, 1),
			currentDate: new Date(),
		};
	},
	computed: {
		...mapGetters("auth", ["user"]),
	},
	created() {
		console.log("用户信息", this.user);
	},
	methods: {
		// 选择日期确认
		birthPickerConfirm(value) {
			this.form.birthDate = moment(value).format("YYYY-MM-DD");
			this.birthPicker = false;
		},
		// 选择身份类型
		codeTypeChange() {
			this.codeTypePicker = true;
			this.$nextTick(() => {
				this.defaultType = Number(this.form.idType) - 1;
			});
		},
		// 选择身份类型确认
		codeTypePickerConfirm(obj) {
			this.form.idType = obj.value;
			this.codeTypePicker = false;
		},
		async handleSubmit(values) {
			let params = { ...this.form };
			const { code, data, message } = await commonAPI.postAction("/password/reset/mobile/checkUserInfo", params);
			if (code == 0) {
				let obj = { username: this.form.username, secretKey: data };
				localStorage.setItem("FORGET_INFO", JSON.stringify(obj));
				toast(message);
				console.log(values);
				let url = this.$route.query.id == 1 ? "/mproblem" : this.$route.query.id == 2 ? "/mbindEmail" : "/mbindPhone";
				console.log(url);
				this.$router.push({
					path: url,
					query: {
						type: "forget",
						userName: this.form.username,
						username: this.form.username,
					},
				});
			} else {
				toast(message);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";

.verify_info::v-deep {
	.code_type_label {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
}
</style>
